import { render, staticRenderFns } from "./referral-info-list-table.vue?vue&type=template&id=2001189a&scoped=true&"
import script from "./referral-info-list-table.vue?vue&type=script&lang=js&"
export * from "./referral-info-list-table.vue?vue&type=script&lang=js&"
import style0 from "./referral-info-list-table.vue?vue&type=style&index=0&id=2001189a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2001189a",
  null
  
)

export default component.exports